import React from "react";
import { useAuth } from "../App";

export const usePermissions = () => {
  const { user } = useAuth();

  const hasPermission = (requiredPermission) => {
    if (!user || (!user.permissions && user.role !== "super_admin"))
      return false;

    // Super admin wildcard check directly from role
    if (user.role === "super_admin") return true;

    // Direct wildcard check from assigned permissions
    if (user.permissions?.includes("*")) return true;

    const reqPermLower = requiredPermission.toLowerCase();

    return (
      user.permissions?.includes(reqPermLower) ||
      user.permissions?.includes(`${reqPermLower}:own`) ||
      user.permissions?.includes(`${reqPermLower}:assigned`)
    );
  };

  return { hasPermission };
};

const HasPermission = ({ requiredPermission, children, fallback = null }) => {
  const { hasPermission } = usePermissions();

  if (hasPermission(requiredPermission)) {
    return <>{children}</>;
  }

  return fallback;
};

export default HasPermission;
